<template>
    <div class="topicPage surveyNew-fullScreen">
        <header class="survey-header">
            <div class="survey-title">
                <img src="../../assets/images/common/nav_logo.png" alt="">
                <h1>{{surveyInfo?surveyInfo.name:''}}</h1>
                <el-button @click="closeFn(hasAnswered)" type="danger" size="small" round><i class="nucfont inuc-close"></i>
                </el-button>
            </div>
        </header>

        <div class="survey-container" v-if="surveyQuestions && surveyQuestions.length">
            <section class="paper-list" v-for="(item, index) in surveyQuestions">
                <ul>
                    <!--评分题-->
                    <li v-if="item.type===1" class="survey-single sur-title">
                        <div class="topic-header">
                            <h3 class="title-order"><b></b>{{index+1+'、'}}</h3>
                            <h3 class="title-des">{{item.title}}</h3>
                        </div>
                        <div class="survey-single-rate">
                            <el-rate v-if="isSolving || isReview" v-model="response[item.id]" :disabled="isReview"></el-rate>
                            <i v-else v-for="i in 5" :key="i" class="el-icon-star-on"></i>
                        </div>
                    </li>

                    <!--单选题-->
                    <li v-if="item.type===2" class="survey-multi">
                        <div class="sur-title multi-title">
                            <h3 class="title-order"><b></b>{{index+1+'、'}}</h3>
                            <h3 class="title-des">{{item.title}}</h3>
                        </div>
                        <ul class="multi-txt">
                            <li v-for="(ele,i) in item.options" :key="i">
                                <label class="option-label">
                                    <el-radio-group v-if="isSolving || isReview" v-model="response[item.id]" :disabled="isReview">
                                        <el-radio class="option-btn" :label="ele.id" :key="ele.id">{{""}}</el-radio>
                                    </el-radio-group>

                                    <el-radio v-else class="option-btn" :value="false" disabled></el-radio>
                                    <p class="option-order">{{String.fromCharCode(i+65)+'.'}}</p>
                                    <p class="option-des">{{ele.title}}</p>
                                </label>
                            </li>
                        </ul>
                    </li>

                    <!--多选题-->
                    <li v-if="item.type==3" class="survey-multi">
                        <div class="sur-title multi-title">
                            <h3 class="title-order"><b></b>{{index+1+'、'}}</h3>
                            <h3 class="title-des">{{item.title}}</h3>
                        </div>
                        <p class="option-limit">（{{$t('questionnaire.maxLimit', [item.limitChoice])}}）</p>
                        <ul class="multi-txt">
                            <li v-for="(ele,i) in item.options" :key="i">
                                <label class="option-label">
                                    <el-checkbox-group v-if="isSolving || isReview"
                                                       v-model="response[item.id]"
                                                       :max="item.limitChoice"
                                                       :disabled="isReview"
                                    >
                                        <el-checkbox class="option-btn" :label="ele.id" :key="ele.id">{{""}}</el-checkbox>
                                    </el-checkbox-group>

                                    <el-checkbox v-else class="option-btn" disabled></el-checkbox>
                                    <p class="option-order">{{String.fromCharCode(i+65)+'.'}}</p>
                                    <p class="option-des">{{ele.title}}</p>
                                </label>
                            </li>
                        </ul>
                    </li>

                    <!--主观题-->
                    <li v-if="item.type==4" class="survey-subjective">
                        <div class="sur-title sub-title">
                            <h3 class="title-order"><b></b>{{index+1+'、'}}</h3>
                            <h3 class="title-des">{{item.title}}</h3>
                        </div>
                        <div v-if="isSolving || isReview" class="subjective-txt">
                            <el-input type="textarea"
                                      v-model="response[item.id]"
                                      :placeholder="$t('tip.input')"
                                      :autosize="{ minRows: 5, maxRows: 10}"
                                      :max="500"
                                      :disabled="isReview"
                            ></el-input>
                        </div>
                        <div v-else class="subjective-txt">
                            {{$t('tip.txtContent')}}
                        </div>
                    </li>
                </ul>
            </section>

            <div class="btn-group" v-if="isSolving">
                <el-button class="btn-submit" @click="toSubmit" type="primary">{{ $t('c.submit') }}</el-button>
            </div>
        </div>
        <div class="fullscreen-wrapper" v-if="loading" v-loading="true">
            <p>{{$t('exam.loading')}}</p>
        </div>
    </div>
</template>

<script>
    import {screenfull} from '@/utils';
    import FullScreen from '@/components/FullScreen';

    export default {
        components: {
            FullScreen,
        },

        props: {
            // *问卷总数据，必传
            surveyInfo: {
                required: true,
            },
            /**
             *  用途，值可以为 'view'、'solve'、'review'
             *      view(默认) 预览问卷的模板，培训师用
             *      reply，作答，学员用
             *      review，回看作答详情，学员用
             */
            usage: {
                type: 'String',
                default: 'view'
            },
            // 作答记录
            surveyRecord: {
                type: Array
            }
        },

        data() {
            return {
                response: {},
                loading: true,
                hasAnswered: false // 之前答过了，无需再答了
            }
        },

        beforeDestroy() {
            screenfull.exit();
        },

        computed: {
            surveyQuestions() {
                return this.surveyInfo.questions || []
            },
            // 是否为答题状态
            isSolving() {
                return this.usage === 'solve' && !this.hasAnswered
            },
            // 是否为回看状态
            isReview() {
                return this.usage === 'review' || this.hasAnswered
            }
        },

        methods: {
            dataLoaded() {
                // 作答模式下
                if (this.isSolving) {

                    // 一、之前做过该问卷，则无须再作答，表现和回查模式一致
                    if (this.surveyRecord && this.surveyRecord.length) {

                        this.hasAnswered = true
                        this.initRecord()
                        this.$confirm('您已作答过该问卷，无须再次作答', '提示', {
                            type: 'success'
                        })

                    // 二、作答新问卷
                    } else {
                        // 初始化作答数据
                        this.initResponse()
                    }

                    // 三、回查模式
                } else if (this.isReview && this.surveyRecord.length) {
                    this.initRecord()
                }
            },

            initResponse() {
                const responseTemplate = {
                    1: 0,
                    2: 0,
                    3: [],
                    4: ''
                }

                this.surveyQuestions.forEach(item => {
                    this.$set(this.response, item.id, responseTemplate[item.type])
                })
            },

            initRecord() {
                this.surveyRecord.forEach(item => {
                    this.$set(this.response, item.questionId, item.answer)
                })
            },

            hasRequiredTopicLeft() {
                // 必答题
                let requiredTopics = this.surveyQuestions.filter(item => item.type !== 4)
                // 必答题数量
                let requiredLength = requiredTopics.length
                // 已答的必答题数量
                let answeredRequiredLength = requiredTopics.filter(item => !this.$isEmpty(this.response[item.id])).length
                // 未答的必答题数量
                let requiredLeft = requiredLength - answeredRequiredLength

                if (requiredLeft) {
                    return this.$message.error(`您还有${requiredLeft}道必选调查项未填写，请配合填写完整！`)
                }

                return false
            },

            async toSubmit() {
                if (this.hasRequiredTopicLeft()) return

                let submitData = []

                for (let id in this.response) {
                    submitData.push({
                        questionId: id,
                        answer: this.response[id],
                    })
                }

                await this.$confirm('确定提交问卷吗？', this.$t('m.tip'))

                this.$api.postQuestionnaireReply(this.surveyInfo.questionnaireId, submitData).then(async() => {
                    await this.$alert('感谢您的反馈！', '提交成功')

                    this.closeFn(true)
                })
            },

            closeFn(finished) {
                this.$emit('close', finished);
            },
        },

        watch: {
            surveyQuestions: {
                handler: function (val) {
                    if (val.length) {
                        this.dataLoaded()

                        setTimeout(() => {
                            this.loading = false;
                        }, 500);
                    }
                },
            }
        },
    }
</script>

<style scoped lang="scss">
    @import '../../style/const.scss';

    @include scrollbar(#999);
    $border: 1px solid #ebebeb;

    .topicPage {
        display: flex;
        flex-direction: column;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #fff;
        z-index: 2000;
    }

    .survey-title {
        display: flex;
        align-items: center;
        padding: 0 30px;
        height: 56px;
        background-color: $c-dark-header;

        img {
            height: 55%;
        }

        h1 {
            flex: 1;
            text-align: center;
            font-size: 20px;
            color: #fff;
            letter-spacing: 2px;
        }
    }

    .survey-container {
        overflow: auto;
        position: relative;
        padding: 20px 0 40px;

        .sur-title {
            padding: 15px 20px;
            background: #fafafc;
            border-bottom: $border;
        }

        .multi-title,
        .sub-title,
        .topic-header {
            position: relative;
            .title-order {
                position: absolute;
                > b:before {
                    content: '*';
                    margin-right: 4px;
                    color: $red;
                }
            }
            .title-des {
                padding-left: 30px;
                word-wrap: break-word;
            }
        }
        .survey-single,
        .survey-multi,
        .survey-subjective {
            width: 70%;
            min-width: 900px;
            margin: 20px auto 0;
            border: $border;
            font-size: 16px;
        }
        .survey-single {
            display: flex;
            .topic-header,
            .survey-single-rate {
                display: inline-block;
            }
            .survey-single-rate {
                width: 160px;
                text-align: center;
                float: right;
                .el-icon-star-on{
                    font-size: 25px;
                    color: #ddd;
                    margin-left: 4px;
                    vertical-align: middle;
                }
            }
            .topic-header {
                flex: 1;
                word-wrap: break-word;
                overflow: hidden;
            }
        }
        .survey-multi {
            .option-limit{
                margin-top: 10px;
                margin-left: 20px;
                color: #aaa;
                font-size: 13px;
            }
            .multi-txt {
                padding: 10px 20px;
                li {
                    //margin: 5px 0;
                }
                .option-label {
                    position: relative;
                    display: flex;
                    align-items: center;
                    padding: 10px 0 10px 5px;
                    color: #979aa3;
                    border-radius: 12px;
                    cursor: pointer;
                    &:hover {
                        background-color: #f9f9f9;
                    }
                    .option-btn{
                        //position: absolute;
                    }
                    .option-order {
                        padding-left: 10px;
                    }
                    .option-des {
                        word-wrap: break-word;
                        padding-left: 5px;
                    }
                }
            }
        }
        .survey-subjective {
            .subjective-txt {
                padding: 15px 20px 15px 50px;
                color: #979aa3;
            }
            .el-textarea {
                width: 800px;
            }
            .title-order > b:before {
                visibility: hidden;
            }
        }
    }

    .btn-group {
        margin-top: 30px;
        text-align: center;
        button {
            width: 120px;
            letter-spacing: 2px;
        }
    }

    .fullscreen-wrapper {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #fff;
        z-index: 3000;

        > p {
            position: absolute;
            top: 53%;
            left: 50%;
            transform: translateX(-50%);
            font-size: 16px;
            color: #000;
            z-index: 9000;
        }
    }

</style>
<style lang="scss">
    .surveyNew-fullScreen{
        .el-radio__label, .el-checkbox__label{
            padding-left: 0;
        }
    }
</style>
